module.exports = __webpack_public_path__ + "img/gk-img.7eab3679.png";